import React from 'react';

const LivestreamingHistory = () => {
	return <div>LivestreamingHistory</div>;
};

export default LivestreamingHistory;
